import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "@reach/router";
import { showMenu } from "../../../redux/reducers/menu/actions";
import { isAuthenticated } from "../../../redux/reducers/user/selectors";
import logoutIcon from "../../../images/logout-icon.svg"
import { Button } from "../Shared";
import { LogoutIcon } from "./Styles";

export default function Account() {
  const dispatch = useDispatch();
  const user = useSelector(isAuthenticated);

  function logout() {
    dispatch(showMenu(false));
  }

  return user ? (
    <Link to="/" >
      <Button
        active
        width="100%"
        style={{background: "transparent", display: "flex"}}
        onClick={() => logout()}
      >
        <LogoutIcon src={logoutIcon} />
      </Button>
    </Link>
  ) : null;
}
